
















































































































































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { mapGetters } from "vuex";
import { Others } from "@/data/BusinessTypes";

@Component({
    ...mapGetters(["accountBook"]),
    components: {
    }
})
export default class InvoicePre extends Vue {
    @Prop({ type: String })
    type!: string;

    // 监测表格滚动,工资表预览也随之滚动 
    @Prop({ type: Number, default: 0 })
    top!: number;

    @Prop({ type: [Array, Object, Number] })
    data!: any;

    accIndex: number = 1;
    ywTypes = Others;

    get isSalary() {
        return this.type === "salaryList";
    }

    mounted() {
        if (!this.isSalary) this.$emit("update:data", (this.data.accIndex = this.accIndex));
    }

    get accPages(): number {
        switch(this.type) {
            case "invoice": return this.data.invoices.length;
            case "dayAccount": return this.data.journals.length;
            case "others": return this.data.otherInvoices.length;
            default: return 1;
        }
    }

    clickSelf() {
        this.$emit("klick", this.data);
    }

    prev() {
        if (this.accIndex > 1) this.data.accIndex = --this.accIndex;
    }
    next() {
        if (this.accIndex < this.accPages)
            this.data.accIndex = ++this.accIndex;
    }

}
